module.exports = __webpack_public_path__ + "img/aplicar_yeso_lanzable.a96e9232.png";